"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@chakra-ui/react");
var classnames_1 = __importDefault(require("classnames"));
var svg_icons_1 = __importDefault(require("../../svgs/svg-icons"));
var ui_common_1 = require("@codametrix/ui-common");
var TimeBasedCodePopover = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var codableTransaction = _a.codableTransaction, handleTimeBasedCodeAdd = _a.handleTimeBasedCodeAdd, handleTimeBasedCodeUpdate = _a.handleTimeBasedCodeUpdate, processInstance = _a.processInstance, updatePopoverState = _a.updatePopoverState, popoverState = _a.popoverState;
    var _j = __read((0, react_1.useState)(((_b = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _b === void 0 ? void 0 : _b.total_time) || ''), 2), time = _j[0], setTime = _j[1];
    var _k = __read((0, react_1.useState)(((_c = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _c === void 0 ? void 0 : _c.age) ||
        ((processInstance === null || processInstance === void 0 ? void 0 : processInstance.age) && ((_d = processInstance === null || processInstance === void 0 ? void 0 : processInstance.age) === null || _d === void 0 ? void 0 : _d.toString())) ||
        ''), 2), age = _k[0], setAge = _k[1];
    var isNewValue = ((_e = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _e === void 0 ? void 0 : _e.total_time) === null;
    var hasAddOnCode = (_f = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _f === void 0 ? void 0 : _f.add_on_code_available;
    var isTimePresent = ((_g = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _g === void 0 ? void 0 : _g.total_time) !== null;
    var handleActionButtonClick = function (ev) {
        ev.stopPropagation();
        if (isNewValue) {
            handleTimeBasedCodeAdd(ev, time, age);
        }
        else {
            handleTimeBasedCodeUpdate(ev, time, age);
        }
        updatePopoverState(false);
    };
    var handleClose = function (ev) {
        var _a, _b, _c;
        // Close the popover and reset the clickTriggered state
        updatePopoverState(false);
        setTime(((_a = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _a === void 0 ? void 0 : _a.total_time) || '');
        setAge(((_b = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _b === void 0 ? void 0 : _b.age) ||
            ((processInstance === null || processInstance === void 0 ? void 0 : processInstance.age) && ((_c = processInstance === null || processInstance === void 0 ? void 0 : processInstance.age) === null || _c === void 0 ? void 0 : _c.toString())) ||
            '');
        ev.stopPropagation();
    };
    var buttonText = '';
    if (hasAddOnCode) {
        buttonText = isTimePresent ? 'Regenerate' : 'Generate';
    }
    else {
        buttonText = 'Save';
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])('time-based-code-popover', {
            magic: hasAddOnCode
        }) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-section" }, { children: [ui_common_1.appServiceLines.isSurgery((_h = processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine) !== null && _h !== void 0 ? _h : 'NONE') && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", __assign({ className: "time-label" }, { children: "Patient Age" })), (0, jsx_runtime_1.jsx)("input", { name: 'age', type: "number", className: (0, classnames_1["default"])('time-input', {
                                    magic: hasAddOnCode
                                }), placeholder: "Enter patient age", value: age, onClick: function (ev) {
                                    ev.stopPropagation();
                                }, onChange: function (e) { return setAge(e.target.value); } })] })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", __assign({ className: "time-label" }, { children: "Total Procedure Time" })), (0, jsx_runtime_1.jsx)("input", { name: 'total-time', type: "number", className: (0, classnames_1["default"])('time-input', {
                                    magic: hasAddOnCode
                                }), placeholder: "Enter minutes", value: time, onClick: function (ev) {
                                    ev.stopPropagation();
                                }, onChange: function (e) { return setTime(e.target.value); } })] })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "button-section" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Button, __assign({ onClick: handleClose, variant: "secondary" }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ onClick: handleActionButtonClick, disabled: !time.trim(), variant: "primary", className: (0, classnames_1["default"])("magic-button", {
                            disabled: !time.trim(),
                            magic: hasAddOnCode
                        }), leftIcon: hasAddOnCode && ((0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeAutomation", svgIconSize: "20" })) }, { children: buttonText }))] }))] })));
};
exports["default"] = TimeBasedCodePopover;
//# sourceMappingURL=time-based-code-popover.js.map